import { render } from "./ProjectGrid.vue?vue&type=template&id=58c63d97"
import script from "./ProjectGrid.vue?vue&type=script&lang=js"
export * from "./ProjectGrid.vue?vue&type=script&lang=js"

import exportComponent from "/Users/casey/Documents/Development/visualspace_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__